var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.499 7.91619C14.499 11.5058 11.5891 14.4158 7.99944 14.4158C4.40983 14.4158 1.49987 11.5058 1.49987 7.91619C1.49987 4.32658 4.40983 1.41661 7.99944 1.41661C11.5891 1.41661 14.499 4.32658 14.499 7.91619ZM8.52966 10.8417C8.23677 11.1346 7.7619 11.1346 7.469 10.8417L5.55248 8.92522C5.25958 8.63233 5.25958 8.15745 5.55248 7.86456C5.84537 7.57167 6.32024 7.57167 6.61314 7.86456L7.24932 8.50074L7.24932 5.35985C7.24932 4.94564 7.5851 4.60985 7.99932 4.60985C8.41353 4.60985 8.74932 4.94564 8.74932 5.35985L8.74932 8.50077L9.38553 7.86456C9.67842 7.57167 10.1533 7.57167 10.4462 7.86456C10.7391 8.15745 10.7391 8.63233 10.4462 8.92522L8.52966 10.8417Z",
    fill: "#0061C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.6f328393a316b0352bb5b15995871a5d.svg";
export { ForwardRef as ReactComponent };